
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppState } from '../../../core/app-state';
import { PointTestLogDoc, PointTestLogService } from '../../../core/services';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';
  
  export class LogEntryRow {

    archived: boolean 
    rowClass: string
    text: string
    timestamp: string

    constructor( public pointTestLogDoc : PointTestLogDoc) {      
      this.archived = pointTestLogDoc.archived
      this.text = pointTestLogDoc.text
      if ( /^\[(\w+\s*)?(start)\].*/i.test(pointTestLogDoc.text) ) {
        this.rowClass = 'start-comment-row'
      } else if (/^\[(\w+\s*)?(end)\].*/i.test(pointTestLogDoc.text)) {
        this.rowClass = 'end-comment-row'
      }
      this.timestamp = pointTestLogDoc.timestamp
    }

  }

  export type PathTestPointSeqSavedEvent = {
    pathTestId:string,
    testPointId:string,
    seqId:string,
    comment:string
  }

  @Component({
    selector: 'app-path-test-point-log',
    templateUrl: './path-test-point-log.component.html',
    styleUrls: ['./path-test-point-log.component.scss']
  })
  export class PathTestPointLogComponent extends FesBaseComponent implements OnInit, OnDestroy {

    @Input() testPointId!: string
    @Input() pathTestId!: string

    @Input('id') set idSet( id: string ) {
      this.init(id)
    }
    id: string 
  
    @Output('commentSaved') commentSaved$ = new EventEmitter<PathTestPointSeqSavedEvent>()
    
    isLoading : boolean = false;
    isOffline: boolean = true
    isSaving: boolean = false;
    comments = new FormControl('');
    validationFailed = false;
    assistanceModal : BsModalRef
    showDeleted = false
    someCommentsDeleted = false
    logRows$ : Observable<LogEntryRow[]>

   
    constructor(appState: AppState, public logService:PointTestLogService, private bsModalService: BsModalService) {
      super(appState)
      this.comments.setValidators( Validators.required )
     }
  
    ngOnInit(): void {
    }
  
    ngOnDestroy(): void {
      this.destroy()
    }

    init(id:string) {
      this.id = id
      this.isLoading = true
      this.logRows$ = this.logService.rxCollection.find().where('taskId').eq(this.id).$.pipe(
        map( (logDocs : PointTestLogDoc[]) => {
          logDocs.sort((a,b)=> b.timestamp?.localeCompare(a.timestamp))
          const logRows = logDocs.map( logEntry => {
            let row = new LogEntryRow(logEntry)
            return row
          })
          this.someCommentsDeleted = logRows.some(le=>le.archived)
          this.isLoading = false
          return logRows
        }),
        catchError(error=>{
          this.isLoading = false
          this.logService.publishError(error,this)
          return []
        })
      )
    }


    get isEditing() {
      return this.comments.value?.length
    }
  
    assistanceDetail(template: TemplateRef<any>, id:string) {
      const initialState = {id: id}
      this.assistanceModal = this.bsModalService.show(template, {initialState});
    }
  
    async onCommentBtnClick() {
      this.validationFailed = this.comments.invalid
      if ( this.validationFailed ) {
        return
      }
  
      if ( await this.logComment(this.comments.value) ) {
        this.comments.setValue('')
      }
    }
  

    async logComment( comment : string ) {
      //console.log(`logComment(text:${text?.substr(0,20)}...)`)
      try {
        const seqId = this.id
        const testPointId = this.testPointId
        const pathTestId = this.pathTestId

        this.validationFailed = false
        this.isSaving = true
        this.isLoading = true
        const bOk = await this.logService.logComment(seqId,comment)
        this.commentSaved$.emit({pathTestId,testPointId,seqId,comment})
        return bOk
      } catch ( error ) {
        this.logService.publishError(error,this)
        this.isLoading = false
        return false
      } finally {
        this.isSaving = false;
      }  
    }
  
    async archive(log: PointTestLogDoc, bArchive : boolean ) {
      this.validationFailed = false
      this.isSaving = true
  
      try {
        log = await log.atomicPatch({ archived: bArchive })
        this.logService.publishSuccess((bArchive?'Deleted':'Restored') + ' log entry',this)
        return true
      } catch ( error ) {
        this.logService.publishError(error,this)
        return false
      } finally {
        this.isSaving = false;
      }
    }
    showDeletedChecked(val: any){
      this.showDeleted = val
    }  
  }
  